import * as Sentry from '@sentry/browser'

function errorLogging(error: Error, context?: unknown) {
  // eslint-disable-next-line no-console
  console.error('errorLogging', error, context)

  Sentry.withScope((scope) => {
    scope.setExtra('context', context)
    Sentry.captureException(error)
  })
}

export default errorLogging
